<template>
  <v-sheet class="emotion-container">
    <div class="emotion-tab">
      <Flicking ref="emotionCate"
                class="pa-3"
                :options="{...flickingOptions, align: 'center', bound: true, moveType: 'freeScroll'}"
      >
        <div class="emotion-tab-item" v-for="(item, index) in value" :key="`slide_${index}`">
          <v-btn :color="index === slideModel ? item.descCont : null"
                 :dark="index === slideModel"
                 rounded depressed :ripple="false"
                 @click="slideModel = index"
          >{{ item.cdNm }}</v-btn>
        </div>
      </Flicking>
    </div>
    <div class="flex-grow-1 overflow-hidden pos-relative">
      <v-btn-toggle
          :multiple="multiple"
          :max="maxSelect"
          borderless
          class="d-flex flex-wrap emotion-group"
          style="position: absolute;left:0;right: 0; top: 0; bottom: 0"
          v-model="selectValue"
          :disabled="disabled"
      >
        <Flicking ref="emotionCateList"
                  style="height: 100%"
                  :options="{ ...flickingOptions, align: 'prev', horizontal: false }"
                  @changed="changed"
        >
          <div
              v-for="n in value.length"
              :key="n"
              :style="{ color: emotionStrArr[n - 1].descCont }"
              ref="lists"
              class="emotion-list"
          >
            <v-btn
                v-for="i in value[n - 1].detailCodeList.length"
                :key="i"
                :value="value[n-1].detailCodeList[i-1].cd"
                text
                plain
                :ref="`btnToggle${value[n-1].detailCodeList[i-1].cd}`"
                :ripple="false"
                class="emotion-txt"
                :disabled="disabled"
                @click="btnToggle(n-1)"
            >
              {{ value[n - 1].detailCodeList[i - 1].cdNm }}
            </v-btn>
          </div>
        </Flicking>
      </v-btn-toggle>
    </div>
    <div v-if="answer.length > 0" class="txt-emotion-wrap justify-center">
      <div v-for="(item, index) in answer" :key="`answer_${index}`">
        <span v-if="disabled" :style="{color: getCodeDetail(item).descCont}">
          {{getCodeDetail(item).cdNm}}
        </span>
        <v-btn v-else
               x-small outlined rounded
               depressed :ripple="false"
               :color="getCodeDetail(item).descCont"
               @click="removeEmotion(item, index)"
        >
          {{getCodeDetail(item).cdNm}}
          <v-icon small class="ms-1 me-n2">mdi-close</v-icon>
        </v-btn>
      </div>
    </div>
<!--    <v-slide-group mandatory @change="changed" class="emotion-list py-5" v-model="slideModel">-->
<!--      <v-slide-item-->
<!--          v-for="n in (value.length)"-->
<!--          :key="n"-->
<!--          v-slot="{ active, toggle }"-->
<!--      >-->
<!--        <v-btn-->
<!--            class="mx-1 emotion-btn"-->
<!--            :class="[{ 'ml-5': n === 1 }, { 'mr-5': n === value.length }]"-->
<!--            :input-value="active"-->
<!--            active-class="white&#45;&#45;text"-->
<!--            :style="-->
<!--              active-->
<!--                ? `backgroundColor:${value[n - 1].descCont}`-->
<!--                : `backgroundColor:#fff`-->
<!--            "-->
<!--            depressed-->
<!--            rounded-->
<!--            height="30"-->
<!--            min-width="70"-->
<!--            text-->
<!--            @click="toggle"-->
<!--        >-->
<!--          {{ value[n - 1].cdNm }}-->
<!--        </v-btn>-->
<!--      </v-slide-item>-->
<!--    </v-slide-group>-->
<!--    <div-->
<!--        ref="container"-->
<!--        v-scroll.self="onScroll"-->
<!--        class="overflow-y-auto"-->
<!--        :style="{ 'max-height': maxHeight }"-->
<!--    >-->
<!--      <v-btn-toggle-->
<!--          :multiple="multiple"-->
<!--          :max="maxSelect"-->
<!--          borderless-->
<!--          class="d-flex flex-wrap emotion-group"-->
<!--          v-model="selectValue"-->
<!--      >-->
<!--        <div-->
<!--            v-for="n in value.length"-->
<!--            :key="n"-->
<!--            :style="{ color: emotionStrArr[n - 1].descCont }"-->
<!--            ref="lists"-->
<!--        >-->
<!--          <v-btn-->
<!--              v-for="i in value[n - 1].detailCodeList.length"-->
<!--              :key="i"-->
<!--              :value="value[n-1].detailCodeList[i-1].cd"-->
<!--              text-->
<!--              plain-->
<!--              :ripple="false"-->
<!--              class="emotion-txt"-->
<!--              @click="btnToggle(n-1)"-->
<!--          >-->
<!--            {{ value[n - 1].detailCodeList[i - 1].cdNm }}-->
<!--          </v-btn>-->
<!--        </div>-->
<!--      </v-btn-toggle>-->
<!--    </div>-->
  </v-sheet>
</template>
<script>
export default {
  props: {
    multiple: Boolean,
    maxSelect: Number,
    // maxHeight: String,
    emotionStrArr: Array,
    answer: Array
  },
  data: () => ({
    // first: true,
    slideModel: 0,
    // offsetTop: 0,
    // selectArr: [] /* 선택된 값 */,
    flickingOptions: {
      autoInit: true,
      defaultIndex: 0
    }
  }),
  computed: {
    cmpltYn () {
      // 완료 구분
      return this.$route.query.cmpltYn === 'true' || this.$route.query.cmpltYn === true
    },
    disabled () {
      return this.cmpltYn
    },
    value: {
      get() {
        return this.emotionStrArr
      },
      set(newValue) {
        return this.$emit('emotionChoice', newValue);
      }
    },
    selectValue: {
      get() {
        return this.answer;
      },
      set(newValue) {
        return this.$emit('emotionChoice', newValue);
      }
    },
    emotionFullList () {
      let arr = []
      this.emotionStrArr.forEach(value => {
        let color = value.descCont
        let detail = value.detailCodeList
        detail.forEach(val => {
          arr.push({...val, descCont: color})
        })
      })
      return arr
    }
  },
  watch: {
    slideModel (nV) {
      this.$refs.emotionCate.moveTo(nV).catch(() => void 0)
      this.$refs.emotionCateList.moveTo(nV)
    }
  },
  mounted () {},
  methods: {
    getCodeDetail (cdAddVal2) {
      let arr = this.emotionFullList.filter(code => code.cd === cdAddVal2)
      if (arr.length > 0) return arr[0]
      return null
    },
    changed (e) {
      this.slideModel = e.index
    },
    btnToggle(n = 0) {
      this.slideModel = n;
      if (this.maxSelect <= this.answer.length) this.$root.$children[0].$refs.toast.toastOpen('top', `${this.maxSelect}개까지 선택이 가능합니다.`)
    },
    removeEmotion (item, index) {
      let detail = this.getCodeDetail(item)
      this.slideModel = Number(detail.cdAddVal2) - 1
      this.selectValue.splice(index, 1)
      this.$emit('emotionChoice', this.selectValue);
    }
  }
}
</script>
